import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useEyeconxStore } from "../../store/eyeconxStore";
import login from "../../services/auth.service";
import { useNavigate } from "react-router-dom";

function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  //const [loading, setLoading] = useState();
  const [message, setMessage] = useState(null);
  const setToken = useEyeconxStore((state) => state.setToken);
  const setUser = useEyeconxStore((state) => state.setUser);
  const setIsAuthenticate = useEyeconxStore((state) => state.setIsAuthenticate);
  
  const token = useEyeconxStore((state) => state.token);
  const isAuthenticated = useEyeconxStore((state) => state.isAuthenticated);
  const user = useEyeconxStore((state)=> state.user)
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    try {
      const response = await login(data.username, data.password).then((res) => {
        if (res.data.statusCode === 200) {
          const user = {
            ID: res.data.uId,
            name: res.data.username,
            role: res.data.role,
            clinicId: res.data.clinicId,
            authorization:'Bearer '+res.data.token,
          };

          setToken(res.data.token);
          setIsAuthenticate(true);
          setUser(user);
        }
      });
    } catch (error) {
        if(!error?.response){
            setMessage('No Server Response')
        } else if (error.response?.status === 400){
            setMessage('Missing Username or Password')
        } else if (error.response?.status === 401){
            setMessage('Unauthorized')
        } else{
            setMessage('Login Failed')
        }
    }
  };

  useEffect(() => {
    if (isAuthenticated && token != null) {
      if(user.role === 'ROLE_ADMIN'){
        navigate("/dashboard");
      }else{
          setMessage("This is only for Admin access!")
          setIsAuthenticate(false)
          setUser(null)
          setToken(null)
      }
    }
  }, [isAuthenticated]);

  return (
    <>
      <main>
        <div className="container">
          <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-4 col-md-6 d-flex flex-column align-item-center justify-content-center">
                  <div className="d-flex justify-content-center py-4">
                    <h1 className="primary d-lg-block">EyeconX Admin</h1>
                  </div>
                 
                  <div className="card mb-3">
                    <div className="card-body">
                      <div className="pt-4 pb-2">
                        <h5 className="card-title text-center pb-0 fs-4">
                          Login to Your Account
                        </h5>
                        <p className="text-center small"></p>
                      </div>

                      <form
                        onSubmit={handleSubmit(onSubmit)}
                        className="row g-3"
                      >
                        <div className="col-12">
                          <label htmlFor="username" className="form-label">
                            Username
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            {...register("username", { required: true })}
                            placeholder="Username"
                          />
                          {errors.userName && (
                            <p className="text-danger">Username is required</p>
                          )}
                        </div>
                        <div className="col-12">
                          <label htmlFor="password" className="form-label">
                            Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            {...register("password", { required: true })}
                            placeholder="Password"
                          />
                          {errors.secret && (
                            <p className="text-danger">Password is required</p>
                          )}
                        </div>
                        {message && <p className="text-danger">{message}</p>}
                        <div className="col-12">
                          <input
                            className="btn btn-primary w-100"
                            value="Submit"
                            type="submit"
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}

export default Login;
